<template>
  <div>
    <a-modal
      v-model="visible"
      title="原料营养指标比对"
      :footer="null"
      :width="1000"
      @cancel="hideModal"
      destroyOnClose
    >
      <div class="differ">
        <!-- <a-input
          v-model="searchText.fullName"
          placeholder="请输入指标名称"
          v-on:blur="search"
          allow-clear
        >
          <a-tooltip slot="suffix" title="Extra information">
            <a-icon type="search" style="color: rgba(0, 0, 0, 0.45)" />
          </a-tooltip>
        </a-input> -->

        <!-- <a-cascader
          :options="typeList"
          :load-data="loadData"
          change-on-select
          @change="onChange"
          style="width: 250px"
          placeholder="请选择指标类型"
          v-model="searchText.nutritionTypeId"
        /> -->
      </div>

      <!-- 表单 -->
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 800, y: 340 }"
        class="tableBox"
        bordered
        :rowKey="(record) => record.id"
      >
        <div slot="t1">
          <p style="padding-left: 38px">原料信息</p>
          <a-checkbox
            v-model="chooseFlag"
            @change="changeSame"
            style="color: #333; font-size: 14px; padding-left: 10px"
          >
            隐藏相同数值项
          </a-checkbox>
          <div>
            <a-cascader
              :options="typeList"
              :load-data="loadData"
              change-on-select
              @change="onChange"
              style="width: 150px; margin: 10px"
              placeholder="请选择指标类型"
              v-model="searchText.nutritionTypeId"
            />
          </div>
        </div>
        <div slot="t2">
          <p v-if="differCompareValue.valueOne.name != undefined">
            {{
              differCompareValue.valueOne.aliasName
                ? differCompareValue.valueOne.aliasName
                : differCompareValue.valueOne.name
            }}
          </p>
          <p
            v-if="differCompareValue.valueOne.name != undefined"
            style="color: #333"
          >
            {{ factoryName1 }}
          </p>

          <a-tooltip placement="top" v-else>
            <span slot="title">未添加对比原料</span>
            <p>选择原料</p>
          </a-tooltip>
          <span @click="showAddContrastModal(0)">添加原料</span>
        </div>
        <div slot="t3">
          <p v-if="differCompareValue.valueTwo.name != undefined">
            {{
              differCompareValue.valueTwo.aliasName
                ? differCompareValue.valueTwo.aliasName
                : differCompareValue.valueTwo.name
            }}
          </p>
          <p
            v-if="differCompareValue.valueTwo.name != undefined"
            style="color: #333"
          >
            {{ factoryName2 }}
          </p>

          <a-tooltip placement="top" v-else>
            <span slot="title">未添加对比原料</span>
            <p>选择原料</p>
          </a-tooltip>

          <span @click="showAddContrastModal(1)">添加原料</span>
        </div>
        <div slot="t4">
          <p>差异</p>
        </div>

        <template slot="f1" slot-scope="text, record">
          <span style="color: #333; text-align: left; padding-left: 40px">{{
            record.name
          }}</span>
        </template>

        <template slot="f2" slot-scope="text, record, index">
          <!-- <span style="color:#333">{{index === 0 ? '' : (!!record.f2 || record.f2 === 0 ? record.f2.toFixed(4) : '-')}}</span> -->
          <span v-if="index === 0"></span>
          <span v-else-if="record.f2 === undefined"></span>
          <span style="color: #333" v-else-if="!!record.f2 || record.f2 === 0"
            >{{ record.f2.toFixed(4) }}
          </span>
          <span style="color: #333" v-else>-</span>
        </template>

        <template slot="f3" slot-scope="text, record, index">
          <!-- <span style="color:#333">{{index === 0 ? '' : (!!record.f3 || record.f3 === 0 ? record.f3.toFixed(4) : '-')}}</span> -->
          <span v-if="index === 0"></span>
          <span v-else-if="record.f3 === undefined"></span>
          <span style="color: #333" v-else-if="!!record.f3 || record.f3 === 0"
            >{{ record.f3.toFixed(4) }}
          </span>
          <span style="color: #333" v-else>-</span>
        </template>

        <template slot="f4" slot-scope="text, record">
          <span v-if="record.f4 > 0" style="color: red"
            >↑{{ record.f4.toFixed(4) }}</span
          >
          <span v-else-if="record.f4 < 0" style="color: green"
            >↓{{ record.f4.toFixed(4) }}</span
          >
          <span v-else-if="record.f4 === 0" style="color: #333">-</span>
        </template>
      </a-table>

      <!-- 添加原料 -->
      <addContrast
        ref="addContrastModel"
        @getDifferCompareId="getDifferCompareId"
        :factoryList="factoryList"
      ></addContrast>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    dataIndex: "name",
    slots: { title: "t1" },
    scopedSlots: { customRender: "f1" },
  },
  {
    dataIndex: "f2",
    align: "center",
    slots: { title: "t2" },
    scopedSlots: { customRender: "f2" },
  },
  {
    dataIndex: "f3",
    align: "center",
    slots: { title: "t3" },
    scopedSlots: { customRender: "f3" },
  },
  {
    dataIndex: "f4",
    align: "center",
    slots: { title: "t4" },
    scopedSlots: { customRender: "f4" },
  },
];
import addContrast from "@/components/Material/MaterialManagement/MaterialEdit/addContrast";
export default {
  components: { addContrast },
  data() {
    return {
      chooseFlag: false,
      visible: false,
      factoryId: window.localStorage.getItem("factoryId"),
      searchText: {
        fullName: "",
        nutritionTypeId: [],
      },
      typeList: [], //指标类型数据
      columns,
      list: [], //table数据

      //添加原料，保存当前选中的原料
      differCompareValue: {
        valueOne: {},
        valueTwo: {},
      },
      factoryList: [],
      cacheData: []
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getDifferList();
        this.getTypeList();
      }
    },
  },
  computed: {
    factoryName1() {
      let { factoryId } = this.differCompareValue.valueOne || {}
      let factory = this.factoryList.find(el => el.factoryId === factoryId) || {}
      return factory.name
    },
    factoryName2() {
      let { factoryId } = this.differCompareValue.valueTwo || {}
      let factory = this.factoryList.find(el => el.factoryId === factoryId) || {}
      return factory.name
    },
  },
  created() {
    this.getFactory()
  },
  methods: {
    async getFactory() {
      let params = {
        current: 1,
        size: 1000,
      };
      const res = await this.$http.get("/nhf-app/formulaManage/myFactory", { params })
      let { success, data } = res;
      if (success) {
        let { records } = data;
        this.factoryList = records || [];
      }
    },
    init() {
      this.visible = !this.visible;
    },

    //获取级联选中的数据,点击搜索
    onChange(value) {
      let nutritionTypeId = value[value.length - 1];
      let id1 = this.differCompareValue.valueOne.rawId;
      let id2 = this.differCompareValue.valueTwo.rawId;
      let factoryIds = `${this.differCompareValue.valueOne.factoryId || ''},${this.differCompareValue.valueTwo.factoryId || ''}`
      if (id1 && id2) {
        this.getDifferCompare({ rawIds: id1 + "," + id2, nutritionTypeId, factoryIds }, true);
      } else {
        if (id1 || id2) this.getDifferCompareAdd({ rawIds: id1 || id2, nutritionTypeId }, !id1 ? 0 : 1);
      }
    },

    //隐藏相同数值项数据
    changeSame(e) {
      if (e.target.checked) {
        this.list = this.list.filter((item) => {
          if (item.f4 !== 0) {
            return item;
          }
        });
      } else {
        this.list = JSON.parse(JSON.stringify(this.cacheData))
      }
    },

    //添加原料，保存当前选中的原料
    getDifferCompareId(choose, addDiffer) {
      if (!choose) {
        this.$set(this.differCompareValue, "valueOne", addDiffer);
      } else {
        this.$set(this.differCompareValue, "valueTwo", addDiffer);
      }
      this.searchText = {
        fullName: "",
        nutritionTypeId: [],
      }
      this.chooseFlag = false
      if (
        this.differCompareValue.valueOne.id != undefined &&
        this.differCompareValue.valueTwo.id != undefined
      ) {
        let id1 = this.differCompareValue.valueOne.rawId;
        let id2 = this.differCompareValue.valueTwo.rawId;
        let factoryIds = `${this.differCompareValue.valueOne.factoryId || ''},${this.differCompareValue.valueTwo.factoryId || ''}`
        this.getDifferCompare({ rawIds: id1 + "," + id2, factoryIds });
      } else {
        this.getDifferCompareAdd({ rawIds: addDiffer.rawId }, choose);
      }
    },

    // 原料对比差异
    async getDifferCompare(data, sameFlag) {
      let obj = {
        factoryId: this.factoryId,
        ...data,
      };
      this.list = []
      let res = await this.$http.post(
        "/nhf-app/factorystaffraw/rawNutritionCompare",
        obj
      );
      if (res.code == 200) {
        let { data } = res;

        let list = []
        list.push({
          name: "营养指标",
          f2: "",
          f3: "",
          f4: "",
          typeId: ''
        });
        data.forEach((element) => {
          list.push({
            name: element.nutritionName,
            f2: element.nutritionValue,
            f3: element.nutritionValue2,
            f4: element.nutritionValueDiff,
            typeId: element.nutritionTypeId
          });
        });
        this.list = [...list]
        this.cacheData = JSON.parse(JSON.stringify(list))
        if (sameFlag) this.changeSame({ target: { checked: this.chooseFlag } })
      }
    },

    //添加原料
    async getDifferCompareAdd(data, choose) {
      let obj = {
        factoryId: this.factoryId,
        ...data,
      };
      let res = await this.$http.post(
        "/nhf-app/factorystaffraw/rawNutritionCompareAddRaw",
        obj
      );
      if (res.code == 200) {
        let { data } = res;

        if (choose == 0) {
          data.forEach((element, index) => {
            this.$set(this.list, index + 1, {
              name: element.nutritionName,
              f2: element.nutritionValue,
            });
          });
        } else {
          data.forEach((element, index) => {
            this.$set(this.list, index + 1, {
              name: element.nutritionName,
              f3: element.nutritionValue,
            });
          });
        }
      }
    },

    // 原料对比列名称，立即渲染
    async getDifferList() {
      let obj = { factoryId: this.factoryId, rawIds: "" };
      let res = await this.$http.post(
        "/nhf-app/factorystaffraw/rawNutritionCompareGetListName",
        obj
      );
      if (res.code == 200) {
        let { data } = res;
        let list = []
        list.push({
          name: "营养指标",
          f2: "",
          f3: "",
          f4: "",
        });
        data.forEach((element) => {
          list.push({
            name: element.nutritionName, f2: "",
            f3: "",
            f4: "",
            typeId: ''
          });
        });

        this.list = [...list]
        this.cacheData = JSON.parse(JSON.stringify(list))
      }
    },

    // 差异对比模态框
    showAddContrastModal(str) {
      this.$refs.addContrastModel.init(str);
    },

    //获取指标类型
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        this.getTypeList(targetOption.id, targetOption) || [];
      }, 0);
    },

    // 关闭模态框，清空数据
    hideModal() {
      this.list = []
      // this.getDifferList()
      this.chooseFlag = false
      this.differCompareValue = {
        valueOne: {},
        valueTwo: {},
      }
      this.searchText = {
        fullName: "",
        nutritionTypeId: [],
      }
    },
    getTypeList(parentId = 0, record) {
      // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail')
      let factoryDetail = obj ? JSON.parse(obj) : {}
      let { deptId } = factoryDetail
      // this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeId?category=nutritiontarget&parentId=${parentId}`)
      this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit?category=nutritiontarget&parentId=${parentId}&deptId=${deptId}`)
        .then((res) => {
          let { success, data = [] } = res;
          if (success) {
            data &&
              data.map((el) => {
                el.value = el.id;
                el.label = el.name;
                el.isLeaf = !el.hasChildren;
                return el;
              });

            if (record) {
              if (data.length) {
                record.children = data;
              } else {
                record.isLeaf = true;
              }
              this.typeList = [...this.typeList];
            } else {
              this.typeList = data;
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.differ {
  display: flex;
  margin-bottom: 16px;
  .ant-input-affix-wrapper {
    width: 250px;
    margin-right: 10px;
  }
}

.tableBox {
  padding: 0;
  p {
    margin: 0;
    font-size: 14px;
    color: orange;
  }
  span {
    font-size: 13px;
    color: rgb(26, 153, 238);
    cursor: pointer;
  }
}
</style>